import { useState } from "react";
import { useSelector } from "react-redux";
import { getSourceSystemContent } from "../../store/selectors";

export const useHeader = () => {
  const { errorUri } = useSelector(getSourceSystemContent);
  const [showModal, setShowModal] = useState<boolean>(false);

  const toggleExitModal = (): void => {
    setShowModal(!showModal);
  };

  const handleExit = (): void => {
    window.location.assign(errorUri);
  };

  return { toggleExitModal, showModal, handleExit };
};
